<template>
  <div>
    <div class="lke-titl">
      <i class="el-icon-caret-right"></i>
      当前位置：修改密码
    </div>
    <div class="lke-text">
      <span>修改密码</span>
    </div>
    <el-form
      label-position="left"
      :rules="rules"
      :model="ruleForm"
      ref="ruleForm"
      label-width="90px"
      class="demo-ruleForm"
    >
      <el-form-item label="旧密码:" prop="oldPassword">
        <el-input
          placeholder="请输入旧密码密码"
          size="mini"
          v-model="ruleForm.oldPassword"
          show-password
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="新密码:" prop="password">
        <el-input
          placeholder="新密码由6-20位数字，大小写字母，符号组成"
          size="mini"
          type="password"
          v-model="ruleForm.password"
          show-password
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item label="再次输入:" prop="password2">
        <el-input
          placeholder="请再次输入新密码"
          type="password"
          size="mini"
          v-model="ruleForm.password2"
          show-password
          autocomplete="off"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          style="margin-right: 30px"
          @click="submit('ruleForm')"
          >修改</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { changeuserinfo } from "@/api/index";
export default {
  props: {},
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入新密码"));
      } else if (value.length < 6) {
        callback(new Error("新密码长度不可低于6位"));
      } else {
        if (this.ruleForm.password2 !== "") {
          this.$refs.ruleForm.validateField("password2");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.ruleForm.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      ruleForm: {
        oldPassword: "",
        password: "",
        password2: "",
      },
      rules: {
        oldPassword: [
          { required: true, message: "请输入旧密码", trigger: "blur" },
          { min: 6, message: "旧密码长度不可低于6位", trigger: "blur" },
        ],
        password: [
          { required: true, validator: validatePass, trigger: "blur" },
        ],
        password2: [
          { required: true, validator: validatePass2, trigger: "blur" },
        ],
      },
    };
  },
  computed: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    submit(formName) {
      //登陆验证
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true;
          let obj = {
            oldPassword: this.ruleForm.oldPassword,
            newPassword: this.ruleForm.password,
          };
          changeuserinfo(obj).then((response) => {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.ruleForm = {
              oldPassword: "",
              password: "",
              password2: "",
            };
          });
          this.loading = false;
        } else {
          return false;
        }
      });
    },
  },
  components: {},
};
</script>

<style>
</style>

<style scoped>
::v-deep.el-input {
  width: 350px;
}
::v-deep.el-form-item {
  margin-bottom: 15px;
}
::v-deep.el-form-item__error {
  padding-top: 0 !important;
}
.lke-titl {
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-bottom: 20px;
}
.lke-titl > i {
  color: #2890f4;
  padding-right: 5px;
  font-size: 20px;
}
.lke-text {
  border: 1px solid #dddddd;
  padding: 15px 0 15px 35px;
  font-weight: bold;
  background: #f9f9f9;
  margin-bottom: 20px;
}
.lke-text > span {
  font-size: 16px;
  color: #2890f4;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/page/grzx/password/password.vue